/*
 * @Author: Nanxing Xiang
 * @Date: 2021-01-19 09:44:50
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-03 16:33:23
 * @Description: file content
 */
import 'finally-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import JSBridge from '@easyvaas/js-bridge';
import App from './App';
import { getAppUserAgentInfo } from '@saturn/ua-parser';
import service from '@saturn/service';
import { remfix } from '@saturn/utils';
import 'src/locales';
const ua = getAppUserAgentInfo();
if (ua) JSBridge.init();
remfix(750, 75);

const params = new URLSearchParams(window.location.search);

// if (process.env.NODE_ENV === 'development') {
//   require('src/mocks');
// }

service
  .init({
    env: process.env.REACT_APP_ENV,
    host: window.location.host,
    sessionid: params.get('sessionid') || ''
  })
  .then(() => {
    //加载React Dom
    ReactDOM.render(<App />, document.getElementById('root'));
  });
